kendo.data.binders.widget.attr = kendo.data.binders.attr.extend({
    refresh: function(key) {
        this.element.element.attr(key, this.bindings.attr[key].get());
    }
})